"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionMutation = exports.purchaseMutation = void 0;
const apollo_boost_1 = require("apollo-boost");
exports.purchaseMutation = (0, apollo_boost_1.gql) `
  mutation purchase($asin: String!, $marketplaceId: String!, $locale: String!, $customerId: String) {
    purchase(asin: $asin, marketplaceId: $marketplaceId, locale: $locale) {
      orderId
    }
  }
`;
exports.actionMutation = (0, apollo_boost_1.gql) `
  mutation action(
    $asin: String
    $tenant: String!
    $marketplaceId: String!
    $actionType: String!
    $data: String!
    $customerId: String
    $customHeaders: JSON
  ) {
    action(
      asin: $asin
      tenant: $tenant
      marketplaceId: $marketplaceId
      actionType: $actionType
      data: $data
      customerId: $customerId
      customHeaders: $customHeaders
    ) {
      response
    }
  }
`;
